<div
  (click)="onClick()"
  [class.topic-card-container-with-image]="topicCard.image"
  class="topic-card-container flex-c"
  [ngStyle]="{
    '--bg-color': topicCard.color80,
    '--text-color': topicCard.color0,
    '--hover-color': topicCard.color70,
  }">
  <img
    [attr.src]="topicCard.image ? topicCard.image : ''"
    [class.topic-card-image]="topicCard.image" />
  <div class="topic-card-content">
    <div class="topic-card-content-text">
      <div class="font-medium-headline-small">
        {{ topicCard.title }}
      </div>
      <div class="font-regular-label-large">{{ topicCard.subtitle }}</div>
    </div>
    <div class="topic-card-content-button">
      <button
        class="inwi-text-button-medium-outline"
        style="background-color: transparent">
        <div class="button-content">
          <div class="button-text">Details Ansehen</div>
        </div>
      </button>
    </div>
  </div>
</div>
